export enum RoleEnum {
  IPS = 'ips',
  TVF = 'tvf',
  TVO = 'tvo',
}
